export default __webpack_public_path__ + "static/media/professional.2c510a25.svg";